export default function Card({ className = "", children }) {
    return <div className={`rounded-2xl border border-black/50 shadow-sm ${className === '' ? 'bg-white text-black' : className}`}>{children}</div>;
}
// This was border-zinc-200 before
export function CardHeader({ className = "", children }) {
    return <div className={`px-4 pt-4 ${className}`}>{children}</div>;
}
export function CardTitle({ className = "", children }) {
    return <h3 className={`text-base font-semibold ${className}`}>{children}</h3>;
}
export function CardContent({ className = "", children }) {
    return <div className={`px-4 pb-4 ${className}`}>{children}</div>;
}
